import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { ManageAdminApiSecretsRootParamList } from "../../../../types";
import { useLoadMoreList } from "../../../../utilities/load-more-list";
import { AccessTokenSession } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_ACCESS_TOKENS } from "../../common";
import { useFocusEffect } from "@react-navigation/native";
import React from "react";
import {
  Button,
  Divider,
  FlatActionList,
  FlatListSearchable,
  Page,
  View,
} from "@towersystems/roam-common-native";
import { FlatListSearchableSkeleton } from "../../../../components/FlatListSearchableSkeleton";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { formatDateToCalendar } from "@towersystems/roam-common/lib/shared-utils";

export type ManageAdminApiSecretsScreenProps = NativeStackScreenProps<
  ManageAdminApiSecretsRootParamList,
  "ManageAdminApiSecretsScreen"
>;

export const ManageAdminApiSecretsScreen = ({
  navigation,
}: ManageAdminApiSecretsScreenProps) => {
  const transitionEnded = useHasTransitionEnded(navigation);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: ({}) => (
        <Button
          isAction
          size="compact"
          label="Generate new API secret"
          onPress={() => navigation.navigate("CreateAdminApiSecretScreen")}
        ></Button>
      ),
    });
  }, []);

  const loadMoreList = useLoadMoreList<AccessTokenSession>({
    initialLoad: false,
    query: QUERY_ACCESS_TOKENS,
    resultKey: "accessTokens",
    sort: { updatedAt: "DESC" },
    customResultExtractor(res: any) {
      if (res) {
        return res;
      }
      return [];
    },
  });

  useFocusEffect(
    // refresh the list when the screen is focused
    React.useCallback(() => {
      loadMoreList.loadMore(undefined, true);
    }, [])
  );

  const renderItem = React.useCallback(
    ({ item }: { item: AccessTokenSession }) => {
      return (
        <FlatActionList.RenderItem
          item={{
            key: item.id,
            title: item.name ?? "Unnamed Access Token",
            subTitle: `Created: ${
              item.createdAt ? formatDateToCalendar(item.createdAt) : "Unknown"
            }`,
            onPress: () => {
              navigation.navigate("ViewAdminApiSecretScreen", {
                secretId: item.id,
              });
            },
          }}
        ></FlatActionList.RenderItem>
      );
    },
    []
  );

  if (
    (loadMoreList.loading && loadMoreList.items.length == 0) ||
    !transitionEnded
  ) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }

  return (
    <Page
      title="Admin API Secrets"
      secondaryTitle="Admin API secrets allow you to access the Roam Admin API. Manage your API secrets here."
      scrollable={true}
    >
      <FlatListSearchable
        renderSearchBarHeader={() => <View />}
        ItemSeparatorComponent={Divider}
        renderItem={renderItem}
        data={loadMoreList.items ?? []}
      />
    </Page>
  );
};
